import { apiUrls } from 'consts'
import { useEffect } from 'react'
import getAll from 'utils/getAll'
import filterableDeviceAttrsProps from '../utils/filterableDeviceAttrsProps'
import getSavedFilters from '../utils/getSavedFilters'
interface useInitFilterProps {
  setManufacturers: Function
  setModels: Function
  setAllModels: Function
  setTypes: Function
  setServiceStatuses: Function
  setDeviceUsages: Function
  setWarrantyStatuses: Function
  setValue: Function
  handleFilterSubmit: Function
  currentCustomer: {} | null
  setCenters: Function
  setAllCenters: Function
  setSites: Function
  setCurrentFilterRawData: Function
  setCurrentFilter: Function
  filters: Array<filterableDeviceAttrsProps>
  reset: Function
  setCurrentSite: Function
  setCurrentManufacturer: Function
}

const useInit = (props: useInitFilterProps) => {
  useEffect(() => {
    props.reset()
    props.filters.forEach((value) => {
      props.setValue(value.name, null)
    })
    props.setCurrentFilterRawData({})
    props.setCurrentFilter({})

    let mappedKeysToArray: Array<{ key: string; data: Array<any> }> = []

    getSavedFilters().then((filtersData) => {
      const centersRequest = getAll(apiUrls.centers).then((data) => {
        props.setCenters(data)
        props.setAllCenters(data)
        mappedKeysToArray.push({ key: 'center_id', data: data })
      })

      const sitesRequest = getAll(apiUrls.sites).then((data) => {
        props.setSites(data)
        mappedKeysToArray.push({ key: 'site_id', data: data })
      })

      const manufacturersRequest = getAll(apiUrls.manufacturers).then((data) => {
        props.setManufacturers(data)
        mappedKeysToArray.push({ key: 'manufacturer_id', data: data })
      })

      const modelsRequest = getAll(apiUrls.models).then((data) => {
        props.setModels(data)
        props.setAllModels(data)
        mappedKeysToArray.push({ key: 'model_id', data: data })
      })

      const typesRequest = getAll(apiUrls.types).then((data) => {
        props.setTypes(data)
        mappedKeysToArray.push({ key: 'type_id', data: data })
      })

      const serviceStatusesRequest = getAll(apiUrls.serviceStatuses).then((data) => {
        props.setServiceStatuses(data)
        mappedKeysToArray.push({ key: 'service_status_id', data: data })
      })

      const deviceUsagesRequest = getAll(apiUrls.filters + '/' + apiUrls.actionDeviceUsages).then(
        (data) => props.setDeviceUsages(data),
      )
      const warrantyStatusesRequest = getAll(
        apiUrls.filters + '/' + apiUrls.actionWarrantyStatuses,
      ).then((data) => props.setWarrantyStatuses(data))

      Promise.all([
        centersRequest,
        sitesRequest,
        manufacturersRequest,
        modelsRequest,
        typesRequest,
        serviceStatusesRequest,
        deviceUsagesRequest,
        warrantyStatusesRequest,
      ]).then(() => {
        if (filtersData !== null) {
          //set pre-saved filter data
          Object.entries(filtersData).forEach((entry) => {
            let [key, value] = entry
            const mappedData: { key: string; data: Array<any> } | undefined =
              mappedKeysToArray.find((obj) => key === obj.key)
            if (mappedData !== undefined) {
              //process array values (check and set if show === 1 and filter value exists in database)
              if (Array.isArray(value)) {
                let customValues: Array<any> = []
                value.forEach((entry) => {
                  const valueObj: { id: number } = entry as { id }
                  const arrVal: {} | undefined = mappedData.data.find(
                    (obj) => valueObj?.id === obj.id && obj.show === 1,
                  )
                  if (arrVal !== undefined) {
                    customValues.push(arrVal)
                  }
                })
                if (customValues.length > 0) {
                  props.setValue(key, customValues)
                }
                return false
              } else {
                //if show === 1 and filter value exists in database, then set as a default filter
                const valueObj: { id: number } = value as { id }
                value = mappedData.data.find(
                  (obj) =>
                    valueObj?.id === obj.id && (!obj.hasOwnProperty('show') || obj.show === 1),
                )
                if (value !== undefined && value !== null) {
                  if (key === 'site_id') {
                    props.setCurrentSite(valueObj.id)
                  }
                  if (key === 'manufacturer_id') {
                    props.setCurrentManufacturer(valueObj.id)
                  }
                }
              }
            }
            props.setValue(key, value)
          })
          props.handleFilterSubmit({ ...filtersData })
        } else {
          props.handleFilterSubmit({})
        }
      })
    })
  }, [props.currentCustomer])
}

export default useInit
